class ClientSelectorController {

    $onInit() {
        this.isButtonLoading = false;
        this.itemsPerPage = 50;
        this.selectedClients = [];
        this.sortIndex = 0;
        this.sortProp = null;
        this.sortPropDisplay = null;

        this.headers = [
            {
                text: 'Select Clients',
                showSort: true,
                columnSize: 'lg'
            }
        ];
    }


    /***
     * Deselect all of the clients and remove them from the selectedClients list.
     */
    resetClientSelection() {
        this.selectedClients.map((client) => client.isSelected = false);
        this.selectedClients = []
    }

    /***
     *  Select all campuses.
     */
    selectAllClients() {
        this.selectedClients = this.clientList;
        this.selectedClients.map((client) => client.isSelected = true);
    }


    /***
     * Sort the list of clients based on "name" column.
     * Iterates through 3 sort states, tracked by this.sortIndex:
     * 0 - no sort
     * 1 - sort ascending
     * 2 - sort descending
     *
     * @param sortColumn    the column to sort the table by. Currently, the only
     *                      option is client name.
     */
    sortList(sortColumn) {
        this.sortPropDisplay = sortColumn;
        this.sortIndex = (this.sortIndex + 1) % 3;
        this.isReverseSort = this.sortIndex === 2;
        this.sortProp = this.sortIndex === 0 ? null : 'name';
    }

     /***
     * Toggle on/off a given client.
     *
     * @param client     the client being checked/unchecked
     */
    toggleClient(client) {
        const selectedClientIndex = this.selectedClients.indexOf(client);
        if (selectedClientIndex > -1) {
            this.selectedClients.splice(selectedClientIndex, 1);
            client.isSelected = false;
        }
        else {
            this.selectedClients.push(client);
            client.isSelected = true;
        }
    }

    /***
     * A callback for the paginator component. Updates the ng-repeat list with the correct starting index, based on
     * the current page.
     *
     * @param startingIndex     the index within the array of items to start displaying in the list.
     */
    updatePaginationStartingIndex(startingIndex) {
        this.startingIndex = startingIndex;
    }

    /***
     * A callback function that passes up the list of client IDs
     */
    buttonClick() {
        if (this.selectedClients.length > 0 && !this.isButtonLoading) {
            this.onButtonClick({clientList: this.selectedClients});
            this.isButtonLoading = true;
        }
    }

}

export default ClientSelectorController;


// WEBPACK FOOTER //
// ./app/common/client-selector/client-selector-controller.js